export default __webpack_public_path__ + "0131622371d352b87e8cbf25e976cfd7.ttf";